import { render, staticRenderFns } from "./ServiceOrderView.vue?vue&type=template&id=06c7c69d&scoped=true&"
import script from "./ServiceOrderView.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7c69d",
  null
  
)

export default component.exports